import React from 'react'
import cn from 'classnames'
import uniqueId from 'lodash/uniqueId'

import ErrorLabel from '../ErrorLabel'

import './styles.scss'
const bc = 'common-check-box'

export const CheckBox: React.FC<any> = ({
  input,
  label,
  title,
  meta: { touched = false, error = null } = {},
  disabled,
  className,
  style,
}) => {
  const id = uniqueId(bc)
  return (
    <div
      className={cn(bc, {
        [className]: className,
      })}
      style={{ ...style }}
    >
      <label
        className={cn(`${bc}__container`, {
          [`${bc}__container--disabled`]: disabled,
        })}
        title={title || label}
        htmlFor={id}
      >
        <input type="checkbox" id={id} {...input} checked={input.value} disabled={disabled} />
        <span className={`${bc}__box`}>
          <span className={`${bc}__mark`} />
        </span>
        <span className={`${bc}__text`}>{label}</span>
      </label>
      <div>{touched && error && <ErrorLabel htmlFor={id} error={error} />}</div>
    </div>
  )
}

export default CheckBox
